import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const {
  REACT_APP_ApiKey,
  REACT_APP_AuthDomain,
  REACT_APP_ProjectId,
  REACT_APP_StorageBucket,
  REACT_APP_MessagingSenderId,
  REACT_APP_AppId,
  REACT_APP_MeasurementId,
} = process.env;
const firebaseConfig = {
  apiKey: REACT_APP_ApiKey,
  authDomain: REACT_APP_AuthDomain,
  projectId: REACT_APP_ProjectId,
  storageBucket: REACT_APP_StorageBucket,
  messagingSenderId: REACT_APP_MessagingSenderId,
  appId: REACT_APP_AppId,
  measurementId: REACT_APP_MeasurementId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
